import type { CheckboxChangeEventType } from '../checkbox/checkbox.component';
import Checkbox from '../checkbox/checkbox.component';

export interface ActionSectionItem {
  value: unknown;
  text: string;
  selected?: boolean;
}

export interface DropDownActionSectionProps {
  items: Array<ActionSectionItem>;
  onItemChanged: (value: ActionSectionItem) => void;
}

const DropDownActionSection = ({ items, onItemChanged }: DropDownActionSectionProps) => {
  const handleOnChange = (value?: CheckboxChangeEventType) => {
    if (value) {
      onItemChanged({
        value: value.name,
        text: value.value,
        selected: value.checked,
      });
    }
  };

  return (
    <div className="odin-w-full odin-flex odin-text-sm odin-flex-col">
      {items.map((item) => (
        <Checkbox
          key={`action_${item.value}`}
          name={item.value as string}
          value={item.text}
          initialChecked={item.selected}
          label={item.text}
          onChange={handleOnChange}
        />
      ))}
    </div>
  );
};

export { DropDownActionSection };
